<template>
    <BModal ref="confirmationModal" :title="title" centered no-close-on-backdrop :header-class="`modal-title text-${type}`" modal-class="no-border-modal">
        <form class="modal-content">
            <div class="modal-body text-center">
                <div class="text-center">
                    <span v-html="question"></span>
                </div>
            </div>
        </form>
        <template #footer="{ cancel }">
            <div class="d-flex justify-content-between align-items-center w-100">
                <button type="button" class="btn btn-secondary" @click="cancel">{{ button1 }}</button>
                <button type="button" :class="`btn btn-${type} ms-2`" @click="confirm()" >{{ button2 }}</button>
            </div>
        </template>
    </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue-next';
import { ref } from 'vue';

export default {
    name: 'ConfirmationModal',
    components : {
        BModal
    },
    props: {
        title: {
            type: String,
            required: true
        },
        question: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        button1: {
            type: String,
            required: true
        },
        button2: {
            type: String,
            required: true
        },
        action: {
            type: Function,
            required: true
        }       
    },
    setup(props) {
        const confirmationModal = ref(null);
        const target = ref(null);

        const show = (value) => {
            target.value = value;
            confirmationModal.value.show();
        };

        const hide = () => {
            confirmationModal.value.hide();
        };

        function confirm() {
            props.action(target.value);
            hide();
        }

        return {
            confirmationModal,
            confirm,
            show,
            hide,
        };
    }
}
</script>

<style>
.no-border-modal .modal-header {
  border-bottom: none !important;
}

.no-border-modal .modal-footer {
  border-top: none !important;
}
</style>
